import { DatePicker, type DatePickerSlotProps } from '@mui/x-date-pickers';
import { DATE_FORMAT, formatDate } from '@src/shared/lib';
import type { ComponentPropsWithoutRef, ComponentRef, ReactNode } from 'react';
import { forwardRef } from 'react';

type DateInputOldProps = ComponentPropsWithoutRef<typeof DatePicker> & {
  required?: boolean;
  fullWidth?: boolean;
  helperText?: ReactNode;
  error?: boolean;
  slotProps?: DatePickerSlotProps;
};
type DateInputOldRef = ComponentRef<typeof DatePicker>;
const DateInputOld = forwardRef<DateInputOldRef, DateInputOldProps>(
  (props, ref) => {
    const {
      required,
      fullWidth,
      helperText,
      error,
      slotProps = {},
      ...rest
    } = props;
    const { textField, ...restSlots } = slotProps;
    const resolvedSlotProps: DatePickerSlotProps = {
      textField: {
        required,
        fullWidth,
        helperText,
        error,
        ...textField,
      },
      ...restSlots,
    };

    return (
      <DatePicker
        ref={ref}
        format={DATE_FORMAT}
        dayOfWeekFormatter={(day) =>
          formatDate(day, { weekday: 'long' }).slice(0, 2)
        }
        slotProps={resolvedSlotProps}
        {...rest}
      />
    );
  },
);
DateInputOld.displayName = 'DateInputOld';
export default DateInputOld;
